import {
	GET_MULTI_PSK,
	GET_MULTI_PSK_SUCCESS,
	GET_MULTI_PSK_FAIL,
	GET_VIEW_MULTI_PSK_FAIL,
	GET_VIEW_MULTI_PSK,
	GET_VIEW_MULTI_PSK_SUCCESS,
	EDIT_VIEW_MULTI_PSK_COMPLETE,
	EDIT_VIEW_MULTI_PSK_FAIL,
	RESET_EDIT_PSK,
	GET_MULTI_PSK_TIP_FAIL,
	GET_MULTI_PSK_TIP_SUCCESS,
	GET_MULTI_PSK_TIP,
} from '../../constants/globalProfileConstants/multiPSKConstants';

/**
 * Reducer function for managing Multi PSK list state.
 *
 * This reducer handles actions related to fetching Multi PSK data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the Multi PSK list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const multiPSKListReducer = (
	state = { multiPSKList: {}, tipMultiPSKList: {} },
	action
) => {
	switch (action.type) {
		case GET_MULTI_PSK:
			return {
				loading: true,
			};
		case GET_MULTI_PSK_SUCCESS:
			return {
				loading: false,
				multiPSKList: action.payload,
			};
		case GET_MULTI_PSK_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		case GET_MULTI_PSK_TIP:
			return {
				tipLoading: true,
			};
		case GET_MULTI_PSK_TIP_SUCCESS:
			return {
				tipLoading: false,
				tipMultiPSKList: action.payload,
			};

		case GET_MULTI_PSK_TIP_FAIL:
			return {
				tipLoading: false,
				tipError: action.payload,
			};
		default:
			return state;
	}
};

export const viewMultiPskReducer = (
	state = { viewMultiPskData: {}, loading: false, error: null },
	action
) => {
	switch (action.type) {
		case GET_VIEW_MULTI_PSK:
			return {
				...state,
				loading: true,
				error: null,
			};
		case GET_VIEW_MULTI_PSK_SUCCESS:
			return {
				...state,
				loading: false,
				viewMultiPskData: action.payload,
				error: null,
			};

		case GET_VIEW_MULTI_PSK_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case EDIT_VIEW_MULTI_PSK_COMPLETE:
			return {
				...state,
				loading: false,
				editMultiPskData: action.payload,
			};
		case EDIT_VIEW_MULTI_PSK_FAIL:
			return {
				...state,
				loading: false,
				editMultiPskError: action.payload,
			};
		case RESET_EDIT_PSK:
			return {
				...state,
				loading: false,
				editMultiPskError: null,
				editMultiPskData: null,
			};
		default:
			return state;
	}
};
